// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"924f8132","299":"326e6a83","409":"2a9c85c0","785":"705c6574"}[chunkId] + ".chunk.js";
};